import { connect } from 'react-redux';
import TreatmentInstanceDialogOpener from '../../../components/DailyPlanning/TreatmentInstanceDialogOpener/TreatmentInstanceDialogOpener';
import { getTreatmentInstanceDetails } from '../../../actions/areas/dailyPlanning';
import { showDialog } from '../../../actions/uiElements';

const mapStateToProps = ({ uiElements: { dialogs } }) => ({ dialogs });

const mapDispatchToProps = dispatch => ({
  show: id => dispatch(showDialog(id)),
  getTreatmentData: async (id, instanceId, occurrence) => {
    await dispatch(getTreatmentInstanceDetails(id, instanceId, occurrence));
  },
});

const TreatmentInstanceDialogOpenerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TreatmentInstanceDialogOpener);

export default TreatmentInstanceDialogOpenerContainer;
